import React, { Component } from 'react';
import {connect} from 'react-redux'
import { withStyles, Button } from '@material-ui/core'
import '../../assets/css/requisition.css'
import {
    getEntities,
    getJobCategories
} from '../../actions/PositionInformationActions'
import {
    onChangeCategory,
    onChangeBenefit,
    onChangeDescription,
    onChangeRequirment,
    createJob
} from '../../actions/CreateJobaction'
import CreateJobForm from '../../layouts/form/CreateJobForm'
import {
    NavLink,
} from 'react-router-dom'
import {
    ROUTE_ADMIN_LOGIN,
    ROUTE_REQUISITION_LIST,
    ROUTE_ADMIN_CV,
    ROUTE_ADMIN_JOB,
    ROUTE_ADMIN_CREATE_JOB
} from '../../utils/routes'
import InformationDialog from '../../components/Dialog/InformationDialog'
import {
    logout
} from '../../actions/LoginAction'

class CreateJob extends Component {

    constructor(props) {
        super(props)
        this.state = {
            error_category: false,
            error_benefit: false,
            error_description: false,
            error_requirment: false
        }
    }

    componentWillMount() {
        this.props.getEntities()
        this.props.getJobCategories()
    }

    render() {

        const { requisition: {category_list, entities }, newjob, form } = this.props.create_job
        const{classes} = this.props
        return (
            <div className={classes.main}>
                <div className="Content">

                <InformationDialog
                    open={this.state.open}
                    handleClose={this.handleClose}
                    handleLogout={this.handleLogout}
                />
                <div className="CvBtn">

                    <NavLink from={ROUTE_ADMIN_CREATE_JOB} to={ROUTE_REQUISITION_LIST}>
                        <Button className={classes.nav_button} variant="outlined" color="secondary">
                            View Requisitions
                        </Button>
                    </NavLink>
                    <NavLink  from={ROUTE_ADMIN_CREATE_JOB} to={ROUTE_ADMIN_JOB}>
                        <Button className={classes.nav_button} variant="outlined" color="secondary">
                            View Jobs
                        </Button>
                    </NavLink>
                    <NavLink  disabled={true}from={ROUTE_ADMIN_CREATE_JOB} to={ROUTE_ADMIN_CREATE_JOB}>
                        <Button disabled={true} variant="outlined" className={classes.nav_button}  color="secondary">
                                    Create Job
                        </Button>
                    </NavLink>
                    <NavLink from={ROUTE_ADMIN_CREATE_JOB} to={ROUTE_ADMIN_CV}>
                        <Button className={classes.nav_button} variant="outlined" color="secondary">
                            View CVs
                        </Button>
                    </NavLink>

                    <Button 
                        onClick={() => this.onLogout()}
                        variant="outlined" 
                        className={classes.nav_button} 
                        color="secondary">
                        Logout
                    </Button>

                </div>

                <div className={this.props.classes.content}>

                    <CreateJobForm
                        categories = {category_list}
                        entities= {entities}
                        selectedCategory = {newjob.category}
                        handleChangeCategory= {this.props.onChangeCategory}
                        selectedBenefit = {newjob.benefits}
                        contract = {form.create_job === undefined ? "unselected":form.create_job.values.contract}
                        handleChangeBenefit= {this.props.onChangeBenefit} 
                        handleChangeDescription={this.props.onChangeDescription}
                        handleChangeRequirment={this.props.onChangeRequirment}
                        error_category = {this.state.error_category}
                        error_benefit={this.state.error_benefit}
                        error_description = {this.state.error_description}
                        error_requirment = {this.state.error_requirment}
                        onSubmit={this.handleSubmit}/>
                </div>
            </div>
            </div>
        )
    }

    onLogout = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleLogout = () => {
        this.setState({
            open: false
        })
        this.props.logout()
        this.props.history.replace(ROUTE_ADMIN_LOGIN, { firstPage: true});
      //  this.props.history.push(ROUTE_ADMIN_LOGIN);

    }

    handleSubmit =() => {

        const { form, newjob} = this.props.create_job
        const data = {
            form: form.create_job.values, 
            position_information: newjob
        }

        if(newjob.benefits.length === 0){
            this.setState({
                error_benefit: true
            })
        }else {
            this.setState({
                error_benefit: false
            })
        }

        if(newjob.category.length === 0){
            this.setState({
                error_category: true
            })
        }else{
            this.setState({
                error_category: false
            })
        }

        if(newjob.description.length === 0){
            this.setState({
                error_description: true
            })
        }else{
            this.setState({
                error_description: false
            })
        }   

        if(newjob.requirements.length === 0){
            this.setState({
                error_requirment: true
            })
        }else{
            this.setState({
                error_requirment: false
            })
        }

        if( newjob.benefits.length !== 0 &&
            newjob.category.length !== 0 &&
            newjob.description.length !== 0 &&
            newjob.requirements.length !== 0){

                this.props.createJob(data)
        }

    }

}

const mapStateToProps = (state) => ({
    create_job: state
})

const mapDispatchToProps = (dispatch) => ({
   getEntities: () => {
       dispatch(
           getEntities()
       )
   },
   getJobCategories: () => {
       dispatch(
           getJobCategories()
       )
   },
   onChangeCategory: (item) => {
        dispatch(
            onChangeCategory(item)
        )
    },
    onChangeBenefit: (item) => {
        dispatch(
            onChangeBenefit(item)
        )
    },
    onChangeDescription: (value) => {
        dispatch(
            onChangeDescription(value)
        )
    },
    onChangeRequirment: (value) => {
        dispatch(
            onChangeRequirment(value)
        )
    },
    createJob: (props) => {
        dispatch(
            createJob(props)
        )
    },
    logout: () => {
        dispatch(
            logout()
        )
    }
   
})

const styles = ({
    main: {
        width: "100%",
        margin: "0 auto",
        paddingTop: "50px",
        marginBottom: "20px",
        borderRadius: "8.9px",
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
        backgroundColor: "#ffffff"
    },
    content: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        backgroundColor: '#FFFFFF'
    },
    nav_button: {
        minWidth: "100px",
        textTransform: "none",
        marginLeft: 10,
        marginRight: 10
    },
})


export default connect(mapStateToProps, mapDispatchToProps) (withStyles(styles)(CreateJob))


//contract, start_date, end_date